import "@/lib/i18n";
import * as Sentry from "@sentry/react";
import { BrowserRouter } from "react-router";
import { Routes } from "./routes";
import { PageMetaUpdater } from "@/lib/hooks/use-page-title";

const fallback = <div>An error occurred. Please refresh the page.</div>;

export default function App() {
  return (
    <BrowserRouter>
      <Sentry.ErrorBoundary fallback={fallback}>
        <PageMetaUpdater />
        <Routes />
      </Sentry.ErrorBoundary>
    </BrowserRouter>
  );
}
